import { Link } from "react-router-dom";
import {
  AIO_PROGRAM,
  AIO_AUDIENCES,
  AIO_WHY,
  AIO_TRUST,
  AIO_STEPS,
  AIO_APP_BANNER,
} from "./landingAllInOneContent";
import { LANDING_SCREEN } from "./landingAssets";
import { listBlogPosts } from "../../Marketing/blog/posts";
import s from "./homeLanding.module.css";

const BENTO = [
  {
    id: "clients",
    title: "Учёт клиентов",
    text: "Клиентская база с историей занятий, оплат и продлений абонементов — без Excel.",
    art: "clients",
    wide: true,
    to: "/crm-dlya-sportivnogo-kluba",
  },
  {
    id: "schedule",
    title: "Расписание и журнал",
    text: "Группы, пробные и отметки на занятии. Списание с абонемента сразу после явки.",
    art: "schedule",
    wide: true,
    to: "/zhurnal-poseshchaemosti",
  },
  {
    id: "crm",
    title: "CRM и оплаты",
    text: "Заявки, должники и выручка в одном кабинете.",
    art: "crm",
    wide: false,
    to: "/abonementy",
  },
  {
    id: "apps",
    title: "Приложение для клиентов",
    text: "Расписание, явка и остаток занятий у родителей на телефоне.",
    art: "apps",
    wide: false,
    to: "/sozdat-prilozhenie-dlya-kluba",
  },
  {
    id: "brand",
    title: "Под брендом клуба",
    text: "Логотип и цвета портала — не чужой сервис на экране.",
    art: "brand",
    wide: false,
    to: "/sozdat-prilozhenie-dlya-kluba",
  },
];

const MODULES = [
  {
    id: "msg",
    title: "Мессенджеры",
    text: "Telegram и Max для напоминаний и связи с клиентами.",
    tone: "violet",
  },
  {
    id: "pay",
    title: "Приём платежей",
    text: "Онлайн-оплата абонементов своими ключами клуба.",
    tone: "orange",
  },
  {
    id: "leads",
    title: "Сбор заявок",
    text: "Пробные и заявки не теряются в переписке.",
    tone: "mint",
  },
  {
    id: "journal",
    title: "Журнал на занятии",
    text: "Отметка с телефона и история посещений.",
    tone: "blue",
  },
  {
    id: "pwa",
    title: "PWA клуба",
    text: "На главный экран без магазинов приложений.",
    tone: "pink",
  },
];

function FeatureArt({ kind }) {
  switch (kind) {
    case "clients":
      return (
        <div className={s.fArt} aria-hidden>
          <div className={`${s.fArtStat} ${s.fArtStatViolet}`}>
            <b>24</b>
            <span>в зале сегодня</span>
          </div>
          <div className={`${s.fArtStat} ${s.fArtStatLight}`}>
            <b>8</b>
            <span>нужно продлить</span>
          </div>
          <div className={s.fArtChart}>
            <i style={{ height: "38%" }} />
            <i style={{ height: "55%" }} />
            <i style={{ height: "42%" }} />
            <i style={{ height: "70%" }} />
            <i style={{ height: "58%" }} />
            <i style={{ height: "82%" }} />
            <i style={{ height: "64%" }} />
          </div>
        </div>
      );
    case "schedule":
      return (
        <div className={s.fArt} aria-hidden>
          <div className={s.fArtField}>Младшая группа · 16:00</div>
          <div className={s.fArtField}>Основной зал</div>
          <div className={s.fArtCal}>
            <span>Пн</span>
            <span>Вт</span>
            <span className={s.fArtCalOn}>Ср</span>
            <span>Чт</span>
            <span>Пт</span>
          </div>
          <div className={s.fArtLesson}>
            <strong>Тренировка</strong>
            <em>16:00–17:30</em>
          </div>
        </div>
      );
    case "crm":
      return (
        <div className={s.fArt} aria-hidden>
          <div className={`${s.fArtStat} ${s.fArtStatViolet}`}>
            <b>12</b>
            <span>новых заявок</span>
          </div>
          <div className={`${s.fArtStat} ${s.fArtStatLight}`}>
            <b>5</b>
            <span>должников</span>
          </div>
          <div className={s.fArtDots}>
            <i className={s.fArtDotV} />
            <i className={s.fArtDotO} />
            <i className={s.fArtDotM} />
            <i className={s.fArtDotB} />
          </div>
        </div>
      );
    case "apps":
      return (
        <div className={s.fArt} aria-hidden>
          <div className={s.fArtAppCard}>
            <div className={s.fArtAppTop}>
              <span />
              <div>
                <strong>Дзюдо · Младшая</strong>
                <em>Завтра, 16:00</em>
              </div>
            </div>
            <button type="button" tabIndex={-1}>
              Открыть
            </button>
          </div>
        </div>
      );
    case "brand":
      return (
        <div className={s.fArt} aria-hidden>
          <div className={s.fArtBrand}>
            <div className={s.fArtLogo}>БС</div>
            <div className={s.fArtSwatch}>
              <i />
              <i />
              <i />
            </div>
            <span>Ваш клуб на экране</span>
          </div>
        </div>
      );
    default:
      return null;
  }
}

function ProgramIcon({ name }) {
  const common = {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
  };

  switch (name) {
    case "users":
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
          <circle cx="22" cy="13" r="3" stroke="currentColor" strokeWidth="2" />
          <path
            d="M5 24c1.5-4 4-6 7-6s5.5 2 7 6M18 24c.8-2.2 2.2-3.5 4-3.5 1.4 0 2.5.7 3.4 2"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );
    case "calendar":
      return (
        <svg {...common}>
          <rect x="5" y="7" width="22" height="18" rx="3" stroke="currentColor" strokeWidth="2" />
          <path d="M5 13h22M11 5v4M21 5v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    case "funnel":
      return (
        <svg {...common}>
          <path
            d="M7 8h18l-6 8v7l-6-3v-4L7 8z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "phone":
      return (
        <svg {...common}>
          <rect x="10" y="4" width="12" height="24" rx="3" stroke="currentColor" strokeWidth="2" />
          <path d="M14 24h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );
    default:
      return null;
  }
}

function AudienceIcon({ name }) {
  const common = {
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
  };

  switch (name) {
    case "whistle":
      return (
        <svg {...common}>
          <path
            d="M10 22c0-5.5 4.5-10 10-10h4c3.3 0 6 2.7 6 6v0c0 2.2-1.8 4-4 4h-2"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
          />
          <circle cx="30" cy="28" r="8" stroke="currentColor" strokeWidth="2.4" />
          <circle cx="30" cy="28" r="3" fill="currentColor" />
        </svg>
      );
    case "glove":
      return (
        <svg {...common}>
          <path
            d="M16 14c0-4 3-7 7-7s7 3 7 7v8c0 6-4 11-7 11s-7-5-7-11v-8z"
            stroke="currentColor"
            strokeWidth="2.4"
          />
          <path d="M16 20h14" stroke="currentColor" strokeWidth="2.4" />
        </svg>
      );
    case "ribbon":
      return (
        <svg {...common}>
          <path
            d="M24 8c6 8 12 12 12 20a12 12 0 11-24 0c0-8 6-12 12-20z"
            stroke="currentColor"
            strokeWidth="2.4"
          />
        </svg>
      );
    case "barbell":
      return (
        <svg {...common}>
          <path
            d="M10 24h28M14 18v12M34 18v12M8 20v8M40 20v8"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
          />
        </svg>
      );
    case "ball":
      return (
        <svg {...common}>
          <circle cx="24" cy="24" r="12" stroke="currentColor" strokeWidth="2.4" />
          <path
            d="M12 24h24M24 12c4 4 4 20 0 24M24 12c-4 4-4 20 0 24"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      );
    case "nodes":
      return (
        <svg {...common}>
          <circle cx="14" cy="16" r="4" stroke="currentColor" strokeWidth="2.4" />
          <circle cx="34" cy="16" r="4" stroke="currentColor" strokeWidth="2.4" />
          <circle cx="24" cy="32" r="4" stroke="currentColor" strokeWidth="2.4" />
          <path d="M17 18l5 10M31 18l-5 10M18 16h12" stroke="currentColor" strokeWidth="2" />
        </svg>
      );
    default:
      return null;
  }
}

const TOP_PILLARS = AIO_PROGRAM.slides.slice(0, 4);

export default function LandingAllInOneSections({ onTryClick }) {
  const blogPosts = listBlogPosts().slice(0, 3);
  const wide = BENTO.filter((f) => f.wide);
  const narrow = BENTO.filter((f) => !f.wide);

  return (
    <>
      <section className={s.f1cPillarsBand} aria-label="Возможности">
        <div className={s.f1cInner}>
          <div className={s.f1cPillars}>
            {TOP_PILLARS.map((slide) => (
              <article key={slide.id} className={s.f1cPillar}>
                <span className={s.f1cPillarIcon} aria-hidden>
                  <ProgramIcon name={slide.icon} />
                </span>
                <h3>{slide.title}</h3>
                <p>{slide.items[0]}</p>
                <ul>
                  {slide.items.slice(1).map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="capabilities" className={s.f1cBentoBand}>
        <div className={s.f1cInner}>
          <h2 className={s.f1cTitle}>
            {AIO_WHY.titleBefore}{" "}
            <span className={s.aioAccentViolet}>{AIO_WHY.titleAccent}</span>
          </h2>
          <div className={s.f1cBentoWide}>
            {wide.map((card) => (
              <Link key={card.id} to={card.to} className={s.f1cBentoCard}>
                <h3>{card.title}</h3>
                <p>{card.text}</p>
                <div className={s.f1cBentoVisual}>
                  <FeatureArt kind={card.art} />
                </div>
              </Link>
            ))}
          </div>
          <div className={s.f1cBentoNarrow}>
            {narrow.map((card) => (
              <Link key={card.id} to={card.to} className={s.f1cBentoCard}>
                <h3>{card.title}</h3>
                <p>{card.text}</p>
                <div className={s.f1cBentoVisual}>
                  <FeatureArt kind={card.art} />
                </div>
              </Link>
            ))}
          </div>
          <div className={s.f1cAskCard}>
            <div>
              <strong>Остались вопросы?</strong>
              <p>Поможем запустить клуб и подскажем по тарифам.</p>
            </div>
            <div className={s.f1cAskActions}>
              <Link
                to="/registraciya"
                className={`${s.btn} ${s.btnPrimary}`}
                onClick={onTryClick}
              >
                Попробовать бесплатно
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className={s.f1cModulesBand}>
        <div className={s.f1cInner}>
          <div className={s.f1cModulesHead}>
            <h2>Всё нужное для клуба — уже внутри</h2>
            <Link to="/vozmozhnosti" className={s.f1cModulesAll}>
              Смотреть все
            </Link>
          </div>
          <div className={s.f1cModulesGrid}>
            {MODULES.map((card) => (
              <article key={card.id} className={s.f1cModuleCard}>
                <span className={`${s.f1cModuleMark} ${s[`f1cModuleMark_${card.tone}`]}`} />
                <h3>{card.title}</h3>
                <p>{card.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id={AIO_AUDIENCES.id} className={s.f1cFitBand}>
        <div className={s.f1cInner}>
          <div className={s.f1cFitLayout}>
            <div className={s.f1cFitCopy}>
              <h2>
                Бай.Спорт подойдёт{" "}
                <span>вашему клубу</span>
              </h2>
              <p>{AIO_AUDIENCES.lead}</p>
              <Link
                to="/registraciya"
                className={`${s.btn} ${s.btnPrimary} ${s.btnLg}`}
                onClick={onTryClick}
              >
                Попробовать бесплатно
              </Link>
            </div>
            <div className={s.f1cFitGrid}>
              {AIO_AUDIENCES.items.map((item) => (
                <Link key={item.id} to={item.to || "/dlya-kogo"} className={s.f1cFitTile}>
                  <span className={s.f1cFitIcon} aria-hidden>
                    <AudienceIcon name={item.icon} />
                  </span>
                  <strong>{item.title}</strong>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className={s.f1cTrustBand}>
        <div className={s.f1cInner}>
          <div className={s.f1cTrustGrid}>
            {AIO_TRUST.items.map((item) => (
              <article key={item.id} className={s.f1cTrustCard}>
                <strong>{item.title}</strong>
                <p>{item.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="steps" className={s.f1cStepsBand}>
        <div className={s.f1cInner}>
          <div className={s.f1cStepsBox}>
            <h2 className={s.f1cTitle}>{AIO_STEPS.title}</h2>
            <div className={s.f1cSteps}>
              {AIO_STEPS.items.map((step) => (
                <article key={step.title} className={s.f1cStep}>
                  <span>{step.num}</span>
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </article>
              ))}
            </div>
            <div className={s.f1cStepsCta}>
              <div>
                <strong>Сделать первый шаг</strong>
                <p>Зарегистрируйте клуб — полный доступ на пробный период.</p>
              </div>
              <Link
                to="/registraciya"
                className={`${s.btn} ${s.btnPrimary} ${s.btnLg}`}
                onClick={onTryClick}
              >
                Начать бесплатно
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section id={AIO_APP_BANNER.id} className={s.f1cAppBand}>
        <div className={`${s.f1cInner} ${s.f1cAppGrid}`}>
          <div className={s.f1cAppCopy}>
            <h2 className={s.f1cTitleLeft}>
              <span className={s.aioAccentViolet}>{AIO_APP_BANNER.titleAccent}</span>
              <br />
              {AIO_APP_BANNER.titleRest}
            </h2>
            <p className={s.f1cAppLead}>{AIO_APP_BANNER.lead}</p>
            <ul className={s.f1cWhyList}>
              {AIO_APP_BANNER.callouts.map((c) => (
                <li key={c.id}>{c.label}</li>
              ))}
            </ul>
            <div className={s.f1cAppActions}>
              <Link
                to="/registraciya"
                className={`${s.btn} ${s.btnPrimary} ${s.btnLg}`}
                onClick={onTryClick}
              >
                {AIO_APP_BANNER.cta}
              </Link>
              <Link to="/sozdat-prilozhenie-dlya-kluba" className={s.f1cTextLink}>
                Про приложение
              </Link>
            </div>
          </div>
          <div className={s.f1cAppShot}>
            <img
              src={AIO_APP_BANNER.src}
              alt={AIO_APP_BANNER.alt}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </section>

      <section className={s.f1cBlogBand}>
        <div className={s.f1cInner}>
          <div className={s.f1cBlogHead}>
            <h2 className={s.f1cTitleLeft}>
              Полезное{" "}
              <span className={s.aioAccentViolet}>для владельцев секций</span>
            </h2>
            <Link to="/blog" className={s.f1cModulesAllDark}>
              Все статьи
            </Link>
          </div>
          <div className={s.f1cBlogGrid}>
            {blogPosts.map((post) => (
              <Link key={post.slug} to={`/blog/${post.slug}`} className={s.f1cBlogCard}>
                <strong>{post.title}</strong>
                <span>{post.description}</span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
